import {
    ENTERPRISE_ROLE, VERSION_TYPE
} from '../enums'

interface ISE_PLATFORM {
    id: string;
    name: string;
}

export enum PlatePermissionType {
    UMU = 1,
    USE_ONLY,
    UMU_AND_USE,
}

// 当前页面需要展示的企业信息
export interface IEnterpriseInfo {
    enterprise_id: string;
    enterprise_name: string;
    real_name: string;
    show_name: string; // 企业后台设置的展示名
    logo: string; // 企业 Logo
    logo_mobile: string; // 企业后台设置的移动端 logo
    config: {
        enroll_auto_register_enterprise: number;
        enterprise_id: string;
        enterprise_name: string;
        hide_enroll_app_guide: number;
        hide_footer: number;
        hide_head_title: number;
        up: string;
    };
    role_type?: ENTERPRISE_ROLE; // EnterpriseRoleType
    version_type?: VERSION_TYPE;
    expire_time?: number; // 时间戳
    role_name?: string;
    platform_permission: number;
    se_platform?: {
        current: ISE_PLATFORM;
        others: ISE_PLATFORM[];
    };
}

export interface IWaterMarkOptionStruct {
    style: IWaterMarkStyleStruct;
    text: string;
}

export interface IWaterMarkStyleStruct {
    font: string;
    text: string;
    color: string;
    size: string;
    rotate: string;
    offsetX: string;
    offsetY: string;
    trasparency: string;
}

export interface IEnterpriseConfig {
    scorm: boolean;
    water_mark: boolean;
    water_mark_options: IWaterMarkOptionStruct;
    video_disable_background_play?: boolean;
    video_delete_text: string;
}
